import { AuthProvider } from '@nvision/oidc';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import store from '@/redux/store';
import RootRoutes from '@/views/routes/RootRoutes';

import './styles/themes/variables.scss';
import './styles/App.scss';
import { useFixPDFDevMode } from './hooks';
import { oidcConfig, services } from './modules/oidc';

const queryClient = new QueryClient();

services.initOIDCAuth();

function App() {
  if (process.env.NODE_ENV === 'development') {
    useFixPDFDevMode();
  }

  return (
    <div className="App">
      <AuthProvider {...oidcConfig}>
        <Provider store={store}>
          <QueryClientProvider client={queryClient}>
            <Router>
              <RootRoutes />
            </Router>
          </QueryClientProvider>
          ,
        </Provider>
      </AuthProvider>
    </div>
  );
}

export default App;
